import { Dispatch } from 'redux';
import { getAllCourseLanguages, CourseLanguageDto } from 'app/shared/api/getCourseLanguages';
import { getCourseLanguageById as getCourseLanguageByIdApi } from 'app/shared/api/getCourseLanguageById';
import {
  saveCourseLanguage as saveCourseLanguageApi,
  SaveCourseLanguageParams,
} from 'app/shared/api/saveCourseLanguage';

export type CourseLanguage = CourseLanguageDto;

export type SavePayload = SaveCourseLanguageParams;

export const FETCH_LANGUAGES = 'COURSE_LANGUAGE_MANAGER/FETCH_LANGUAGES';
export const SET_LANGUAGES = 'COURSE_LANGUAGE_MANAGER/SET_LANGUAGES';

export const SAVE_LANGUAGE_REQUEST = 'COURSE_LANGUAGE_MANAGER/SAVE_LANGUAGE_REQUEST';
export const SAVE_LANGUAGE_SUCCESS = 'COURSE_LANGUAGE_MANAGER/SAVE_LANGUAGE_SUCCESS';
export const SAVE_LANGUAGE_FAILURE = 'COURSE_LANGUAGE_MANAGER/SAVE_LANGUAGE_FAILURE';

export const LANGUAGE_SET_FILTER = 'COURSE_LANGUAGE_MANAGER/SET_FILTER';
export const LANGUAGE_MODAL_OPEN = 'COURSE_LANGUAGE_MANAGER/MODAL_OPEN';
export const LANGUAGE_MODAL_CLOSE = 'COURSE_LANGUAGE_MANAGER/MODAL_CLOSE';

export const setLanguages = (items: CourseLanguage[]) => ({
  type: SET_LANGUAGES,
  payload: items,
});

export const setFilter = (value: string) => ({
  type: LANGUAGE_SET_FILTER,
  payload: value,
});

export const openModal = (editing: CourseLanguage | null) => ({
  type: LANGUAGE_MODAL_OPEN,
  payload: editing,
});

export const closeModal = () => ({
  type: LANGUAGE_MODAL_CLOSE,
});

export const fetchCourseLanguages = () => async (dispatch: Dispatch) => {
  dispatch({ type: FETCH_LANGUAGES });
  try {
    const data = await getAllCourseLanguages();
    dispatch(setLanguages(Array.isArray(data) ? (data as CourseLanguage[]) : []));
  } catch {
    dispatch(setLanguages([]));
  }
};

export const fetchCourseLanguageById =
  (id: number) =>
  async (): Promise<CourseLanguage | null> => {
    try {
      const dto = await getCourseLanguageByIdApi(id);
      return (dto as CourseLanguage) ?? null;
    } catch {
      return null;
    }
  };

export const saveCourseLanguage =
  (payload: SavePayload) =>
  async (dispatch: Dispatch) => {
    dispatch({ type: SAVE_LANGUAGE_REQUEST });
    try {
      const res = await saveCourseLanguageApi(payload);
      if (!res.ok) {
        dispatch({ type: SAVE_LANGUAGE_FAILURE, error: res.message });
        return { ok: false, message: res.message };
      }
      dispatch({ type: SAVE_LANGUAGE_SUCCESS });
      await (fetchCourseLanguages() as any)(dispatch);
      return { ok: true };
    } catch (error: any) {
      const message = error?.message || 'Failed to save course language.';
      dispatch({ type: SAVE_LANGUAGE_FAILURE, error: message });
      return { ok: false, message };
    }
  };